export const MasterCardIcon = () => {
  return (
    <svg
      width="22"
      height="14"
      viewBox="0 0 22 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8733 1.66092H7.98391V12.3392H13.8733V1.66092Z"
        fill="#FF5F00"
      />
      <path
        d="M8.35789 7.00003C8.35696 5.97164 8.58793 4.95651 9.03331 4.0315C9.4787 3.10649 10.1268 2.29584 10.9286 1.66091C9.93572 0.87346 8.74324 0.383755 7.48751 0.24777C6.23178 0.111784 4.96346 0.335 3.82753 0.891914C2.69159 1.44883 1.73386 2.31697 1.06382 3.3971C0.393776 4.47723 0.0384521 5.72578 0.0384521 7.00003C0.0384521 8.27428 0.393776 9.52283 1.06382 10.603C1.73386 11.6831 2.69159 12.5512 3.82753 13.1081C4.96346 13.6651 6.23178 13.8883 7.48751 13.7523C8.74324 13.6163 9.93572 13.1266 10.9286 12.3391C10.1268 11.7042 9.47872 10.8936 9.03333 9.96855C8.58794 9.04354 8.35696 8.02842 8.35789 7.00003Z"
        fill="#EB001B"
      />
      <path
        d="M21.8185 7.00003C21.8185 8.27426 21.4633 9.5228 20.7933 10.6029C20.1232 11.6831 19.1655 12.5512 18.0296 13.1081C16.8937 13.665 15.6254 13.8883 14.3697 13.7523C13.114 13.6163 11.9215 13.1266 10.9286 12.3391C11.7297 11.7036 12.3774 10.8928 12.8227 9.96793C13.268 9.04307 13.4994 8.02826 13.4994 7.00003C13.4994 5.9718 13.268 4.95699 12.8227 4.03212C12.3774 3.10726 11.7297 2.29648 10.9286 1.66091C11.9215 0.873459 13.114 0.383752 14.3697 0.247768C15.6254 0.111784 16.8937 0.33501 18.0296 0.89193C19.1655 1.44885 20.1232 2.31699 20.7933 3.39712C21.4633 4.47725 21.8185 5.72579 21.8185 7.00003Z"
        fill="#F79E1B"
      />
      <path
        d="M21.1763 11.2082V10.9895H21.2637V10.945H21.0412V10.9895H21.1286V11.2082H21.1763ZM21.6083 11.2082V10.9446H21.5401L21.4617 11.1259L21.3832 10.9446H21.315V11.2082H21.3631V11.0093L21.4367 11.1808H21.4866L21.5602 11.0089V11.2082H21.6083Z"
        fill="#F79E1B"
      />
    </svg>
  );
};
